import { Avatar, Chip, ChipProps } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PersonIcon from '@mui/icons-material/Person';
import type { Actor } from '../../types/entities/actor.entity';

type Props = {
    actor: Actor | null | undefined;
    size?: ChipProps['size'];
    emptyLabel?: string;
};

export const ActorChip = ({ actor, size = 'small', emptyLabel = '—' }: Props) => {
    if (!actor) {
        return <span style={{ color: '#999' }}>{emptyLabel}</span>;
    }
    const isBot = actor.type === 'bot';
    const color = actor.color || (isBot ? '#64748b' : '#1976d2');

    return (
        <Chip
            size={size}
            variant="outlined"
            title={actor.role ? `${actor.name} — ${actor.role}` : actor.name ?? actor.key}
            avatar={
                <Avatar sx={{ bgcolor: `${color} !important`, color: '#fff !important' }}>
                    {isBot ? <SmartToyIcon sx={{ fontSize: 14 }} /> : <PersonIcon sx={{ fontSize: 14 }} />}
                </Avatar>
            }
            label={actor.name ?? actor.key}
            sx={{ borderColor: color, maxWidth: 200, opacity: actor.is_active === false ? 0.6 : 1 }}
        />
    );
};
